import { Component, OnInit } from '@angular/core';

import { VersionService } from '../version.service';
import { COMMIT_HASH } from '../../version';

/**
 * Shared "new version available" reload overlay, used by both the dashboard and
 * Claudia. It ensures the version WebSocket is connected (idempotent) and renders
 * from the centralized reload state on {@link VersionService}, so the reload UX is
 * identical everywhere and lives in exactly one place.
 */
@Component({
  selector: 'app-version-overlay',
  template: `
    <div *ngIf="vs.reloadPending"
         style="position:fixed;inset:0;background:rgba(0,0,0,0.65);z-index:1070;display:flex;align-items:center;justify-content:center;">
      <div class="card text-center shadow-lg p-4" style="max-width:360px;width:100%;">
        <div class="fs-1 mb-2">🚀</div>
        <h5 class="card-title">{{ 'NEUE_VERSION' | translate }}</h5>
        <p class="card-text text-muted small mb-3">{{ 'NEUE_VERSION_HINWEIS' | translate }}</p>
        <button class="btn btn-primary w-100" (click)="reloadNow()">
          {{ 'NEUE_VERSION_LADEN' | translate }} ({{ vs.reloadCountdown }})
        </button>
      </div>
    </div>
  `,
})
export class VersionOverlayComponent implements OnInit {
  constructor(public vs: VersionService) {}

  ngOnInit(): void {
    this.vs.connect(COMMIT_HASH);   // idempotent — also starts the WS on the /claudia route
  }

  reloadNow(): void {
    location.reload();
  }
}
